import React, { useEffect, useState } from 'react';
import { Image, Modal, Skeleton, Space, Table } from 'antd';
import { CheckCircleFilled, CloseCircleOutlined } from '@ant-design/icons';
import './CompareProductsTableModal.scss';
import type { ButtonProps } from 'antd/lib/button/button';
interface CompareProductsTableModalProps {
  title?: string;
  open?: boolean;
  cancelText?: string;
  okText?: string;
  onCancel?: () => void;
  onOk?: () => void;
  cancelButtonProps?: ButtonProps;
  productsToCompare?: {
    comparisonProducts: any[] | undefined;
    unionOfFeatures: string[] | undefined;
  };
}
const CompareProductsTableModal = ({
  title,
  open,
  okText,
  cancelText,
  onCancel,
  onOk,
  cancelButtonProps,
  productsToCompare
}: CompareProductsTableModalProps) => {
  const [comparisonProducts, setComparisonProducts] = useState<any[]>([]);
  const [unionOfFeatures, setUnionOfFeatures] = useState<string[] | undefined>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    productsToCompare?.comparisonProducts && setComparisonProducts(productsToCompare?.comparisonProducts);
    setUnionOfFeatures(productsToCompare?.unionOfFeatures);
    setLoading(false);
  }, [productsToCompare]);

  const columns: any[] = [
    {
      title: 'Features',
      dataIndex: 'feature',
      key: 'feature',
      width: 200
    },
    ...comparisonProducts.map((product: any) => ({
      title: (
        <Space>
          <Image src={product.logo} style={{ maxHeight: 44 }} />
          {product?.name}
        </Space>
      ),
      dataIndex: product?.name,
      key: product.id,
      width: 200,
      align: 'center',
      render: (_text: any, record: any) => (
        <div>
          <span>
            {product?.features?.includes(record.feature) ? (
              <CheckCircleFilled style={{ color: '#0FBB20', fontSize: 20 }} />
            ) : (
              <CloseCircleOutlined style={{ color: '#404040', fontSize: 20 }} />
            )}
          </span>
        </div>
      )
    }))
  ];
  const dataSource = unionOfFeatures?.map((feature: any) => {
    const row: any = { feature };
    comparisonProducts?.forEach((product: any) => {
      row[product.name] = !!product?.features?.includes(feature);
    });
    return row;
  });
  const handleCancel = () => {
    onCancel && onCancel();
    setUnionOfFeatures([]);
    setComparisonProducts([]);
  };
  return (
    <Modal
      className="compare-products-table"
      title={title}
      open={open}
      onCancel={handleCancel}
      cancelText={cancelText}
      okText={okText}
      onOk={onOk}
      cancelButtonProps={cancelButtonProps}
      centered
      style={{
        top: 20,
        width: 1400
      }}
    >
      <Skeleton loading={loading}>
        <Table
          bordered={true}
          size="large"
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          scroll={{
            x: 1240,
            y: 500
          }}
        />
      </Skeleton>
    </Modal>
  );
};
export default CompareProductsTableModal;
